<template>
  <div>
    <DeleteModal
      modal-id="modal-delete"
      @deleteToggle="deleteItem"
    />

    <b-modal
      id="modal-print-employees"
      centered
      :no-close-on-backdrop="true"
      :title="$t('employee.print-salaries')"
      :ok-title="$t('employee.print-salaries')"
      :cancel-title="$t('common.cancel')"
      :ok-disabled="printChoice === 'job' && !hasPrintJobTitle"
      @ok="confirmEmployeesPrint"
    >
      <b-form-group>
        <b-form-radio-group
          v-model="printChoice"
          :options="printChoiceOptions"
          stacked
          name="print-choice"
        />
      </b-form-group>

      <b-form-group
        v-if="printChoice === 'job'"
        :label="$t('employee.job-title')"
      >
        <AutoComplete
          v-model="printJobTitle"
          endpoint="jobs"
          text-title="title"
          :no-sort="true"
        />
      </b-form-group>
    </b-modal>

    <b-modal
      id="modal-edit"
      :no-close-on-backdrop="true"
      ok-only
      :ok-title="$t('common.ok')"
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('employee.employee')}`
          : `${$t('common.edit')} ${$t('employee.employee')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group
              :label="$t('common.name')"
              label-for="name"
            >
              <b-form-input
                v-model="EditForm.full_name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">
                {{ errorForm.full_name }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group
              :label="$t('employee.job-title')"
              label-for="name"
            >
              <AutoComplete
                v-model="jobTitleObj"
                :serializer="(val) => val"
                param-query="search"
                endpoint="jobs"
                text-title="title"
                :no-sort="true"
                @input="onSubcategorySelected"
              />
              <p class="text-danger mt-1">
                {{ errorForm.job_title }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group
              :label="$t('employee.base-salary')"
              label-for="name"
            >
              <b-form-input
                v-model="EditForm.base_salary"
                type="number"
                :placeholder="$t('employee.base-salary')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          ref="button"
          variant="primary"
          class="m-0"
          :disabled="loading"
          block
          @click="submitItem"
        >
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner
            v-else
            small
          />
        </b-button>
      </template>    </b-modal>
    <b-card :title="$t('employee.employees')">
      <div>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <h2>{{ $t("common.filter") }} {{ $t("employee.employees") }}</h2>
            <br>
          </b-col>

          <b-col
            md="4"
            cols="12"
          >
            <b-form-group
              :label="$t('common.name')"
              label-for="name"
            >
              <b-form-input
                v-model="name"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="4"
            cols="12"
          >
            <b-form-group
              :label="$t('employee.job-title')"
              label-for="name"
            >
              <AutoComplete
                v-model="jobTitle"
                endpoint="jobs"
                text-title="title"
                :no-sort="true"
                @input="onSubcategorySelected"
              />
              <!-- <b-form-input
                v-model="jobTitle"
                :placeholder="$t('employee.job-title')"
              /> -->
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <br>
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button
              variant="primary"
              class="mx-2"
              @click="getEmployeesList()"
            >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" /> </b-button><b-button
                variant="primary"
                @click="calculateSalary()"
              >
                {{ $t("employee.calculate-salary") }}
              </b-button>
            <b-button
              variant="primary"
              class="mx-2"
              :disabled="printLoading"
              @click="openEmployeesPrintModal"
            >
              <span v-if="!printLoading">{{ $t("employee.print-salaries") }}</span>
              <b-spinner
                v-else
                small
              />
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("employee.employees") }}</h2>
          <div>
            <b-button
              v-if="$store.state.app.permissions.includes('store-employees')"
              class="mx-2"
              variant="primary"
              @click="show(EditForm, 'create')"
            >
              {{ $t("common.create") }} {{ $t("employee.employee") }}
            </b-button>
            <!-- <b-button
              variant="primary"
              @click="
                $router.push({
                  name: 'create-employees-salary',
                })
              "
              v-if="
                $store.state.app.permissions.includes('store-employeeSalary')
              "
            >
              Create Employees Salary
            </b-button> -->
          </div>
        </div>
        <div class="mb-2">
          <b-form-checkbox
            v-model="allChecked"
            @change="allcheck(allChecked)"
          >
            <span
              class="fs-2"
              style="font-size: medium ; font"
            >
              {{ $t("employee.select-all") }}</span></b-form-checkbox>
        </div>

        <b-table
          v-if="!loading"
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
        >
          <!-- Column for the checkbox -->
          <template #cell(status)="data">
            <!-- {{ data.item.salary? data. }} -->
            <div v-if="data.item.salary">
              <span
                v-if="data.item.salary.status == true"
                class="text-success"
                style="font-size: 17px; font-weight: bold"
              >
                {{ $t("employee.salary-recieved") }}</span>
              <span
                v-if="data.item.salary.status == false"
                style="font-size: 17px; font-weight: bold"
                class="text-warning"
              >
                {{ $t("employee.salary-not-recieved") }}</span>
            </div>
            <div v-else>
              <span
                class="text-danger"
                style="font-size: 17px; font-weight: bold"
              >
                {{ $t("employee.no-salary") }}</span>
            </div>
          </template>
          <template #cell(job_title)="data">
            <div v-if="data.item.job">
              {{ data.item.job.title }}
            </div>
          </template>
          <template #cell(additional_salary)="data">
            <div v-if="data.item.salary">
              {{ data.item.salary.additional_salary }}
            </div>
          </template>
          <template #cell(deduction_salary)="data">
            <div v-if="data.item.salary">
              {{ data.item.salary.deduction_salary }}
            </div>
          </template>
          <template #cell(salary)="data">
            <div v-if="data.item.salary">
              {{ data.item.salary.total_salary }}
            </div>
          </template>
          <template #cell(salary_check)="data">
            <b-form-checkbox
              v-if="data.item.salary == null"
              :id="`checkbox-${data.item.id}`"
              v-model="data.item.checked"
              :name="`checkbox-${data.item.id}`"
              @change="updateSalaryList(data.item.id, data.item.checked)"
            />
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <!-- @click="printId(data.item.id)" -->
              <b-button
                variant="outline-primary"
                size="sm"
                pill
                class="mx-2"
                @click="
                  $router.push({
                    name: 'employees-salary',
                    params: {
                      id: data.item.id,
                    },
                  })
                "
              >
                {{ $t("employee.despense-salary") }}
              </b-button>
              <ActionsButtons
                delete-perm="delete-employees"
                edit-perm="update-employees"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span
                class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("employee.employees") }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getEmployeesList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <Employee
      v-if="isPrinting"
      id="employee-print"
      :data="allEmployeesForPrint"
    />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormCheckbox,
  BModal,
  BFormRadioGroup,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import permissionChecker from '@/mixins/permissionChecker'
import ActionsButtons from '@/components/common/ActionsButtons.vue'
import DeleteModal from '@/components/modals/DeleteModal.vue'

import Employee from '@/components/printables/Employees.vue'

const AutoComplete = () => import('@/components/common/AutoComplete.vue')
export default {

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    BFormCheckbox,
    BModal,
    BFormRadioGroup,
    Employee,
    ActionsButtons,
    DeleteModal,
    AutoComplete,
  },
  mixins: [permissionChecker],
  data() {
    return {
      take: 9999,
      loading: true,
      printLoading: false,
      isNotValid: false,
      dataCount: 0,
      data: [],
      allEmployeesForPrint: [],
      isPrinting: false,
      printChoice: 'all',
      printJobTitle: null,
      printChoiceOptions: [
        { text: this.$t('employee.select-all-employees'), value: 'all' },
        { text: this.$t('employee.print-salaries-by-job-title'), value: 'job' },
      ],
      name: '',
      jobTitle: null,
      EditForm: {
        full_name: '',
        job_title: '',
        base_salary: '',
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        full_name: '',
        job_title: '',
        base_salary: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        { key: 'salary_check', label: '#', sortable: true },
        { key: 'full_name', label: this.$t('common.name'), sortable: true },
        {
          key: 'job_title',
          label: this.$t('employee.job-title'),
          sortable: true,
        },
        {
          key: 'base_salary',
          label: this.$t('employee.base-salary'),
          sortable: true,
        },

        {
          key: 'additional_salary',
          label: this.$t('employee.add-salary'),
          sortable: true,
        },

        {
          key: 'deduction_salary',
          label: this.$t('employee.deducation-salary'),
          sortable: true,
        },
        { key: 'salary', label: this.$t('employee.salary'), sortable: true },
        { key: 'salary.paid_date', label: this.$t('employee.paid_date'), sortable: true },
        { key: 'status', label: this.$t('employee.status'), sortable: true },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      salaries: [],
      allChecked: false,
      jobTitleObj: {},
    }
  },
  computed: {
    hasPrintJobTitle() {
      return Boolean(this.printJobTitle && this.printJobTitle.id)
    },
  },
  watch: {
    jobTitleObj() {
      if (this.jobTitleObj.id) {
        this.EditForm.job_title = this.jobTitleObj.id
        this.EditForm.base_salary = this.jobTitleObj.base_salary
      }
    },
  },
  mounted() {
    this.getEmployeesList()
  },
  methods: {
    openEmployeesPrintModal() {
      this.printChoice = 'all'
      this.printJobTitle = null
      this.$bvModal.show('modal-print-employees')
    },
    async confirmEmployeesPrint(bvModalEvt) {
      // Keep modal open if job-title is required but missing
      if (this.printChoice === 'job' && !(this.printJobTitle && this.printJobTitle.id)) {
        bvModalEvt.preventDefault()
        return
      }
      await this.fetchAllAndPrint({
        mode: this.printChoice,
        jobId: this.printJobTitle ? this.printJobTitle.id : null,
      })
    },
    async calculateSalary() {
      if (this.salaries.length > 0) {
        (this.params.form = { employee_ids: this.salaries }),
        (this.params.path = '/calculate-employee-salaries'),
        this.$store
          .dispatch('create', this.params)
          .then(response => {
            this.getEmployeesList()
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                variant: 'success',
                text: 'Salary Caculated Successfuly',
              },
            })
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                variant: 'danger',
                text: 'Something Went Wrong!',
              },
            })
          })
      } else {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Salary Calculation Failed',
            icon: 'danger',
            variant: 'danger',
            text: 'Select Employees to Calculate their salaries',
          },
        })
      }
    },
    async fetchAllAndPrint(options = { mode: 'all', jobId: null }) {
      this.printLoading = true
      try {
        let url = '/employees?page=1&take=9999&sort=-id&include=salary,job'
        if (options && options.mode === 'job' && options.jobId) {
          url += `&filter[job_id]=${options.jobId}`
        }

        await this.getList(url)
        this.allEmployeesForPrint = (this.all_data && this.all_data.data) ? this.all_data.data : []
        if (!this.allEmployeesForPrint.length) {
          this.allEmployeesForPrint = this.data || []
        }
        this.isPrinting = true
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 300))
        window.print()
        this.isPrinting = false
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'danger',
            text: 'Failed to prepare salaries print data',
          },
        })
      } finally {
        this.printLoading = false
      }
    },
    ReCalculateSalary(item) {
      (this.params.form = { employee_ids: item.id }),
      (this.params.path = `/recalculate-employee-salary/${item.id}`),
      this.$store
        .dispatch('put', this.params)
        .then(response => {
          this.getEmployeesList()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              variant: 'success',
              text: 'Salary Re-caculated Successfuly',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Something Went Wrong!',
            },
          })
        })
    },
    updateSalaryList(id, isChecked) {
      if (isChecked) {
        if (!this.salaries.includes(id)) {
          this.salaries.push(id)
        }
      } else {
        this.salaries = this.salaries.filter(salaryId => salaryId !== id)
      }
    },
    allcheck(isAllChecked) {
      this.salaries = []
      if (isAllChecked) {
        this.data.map(async e => {
          if (e.salary == null) {
            this.updateSalaryList(e.id, true)

            // check if there are any null value in the obj we sending

            let url = `/employees?page=${this.page}&take=${this.take}&sort=-id&include=salary`

            if (this.name) {
              url += `&filter[full_name]=${this.name}`
            }
            if (this.jobTitle && this.jobTitle.id) {
              url += `&filter[job_id]=${this.jobTitle.id}`
            }

            await this.getList(url)
            this.dataCount = this.all_data.total
            this.data = this.all_data.data
            this.data.map(e => {
              e.checked = true
            })
          }
        })
      } else {
        this.data.map(async e => {
          if (e.salary == null) {
            e.checked = true

            // this.updateSalaryList(e.id, true);

            // check if there are any null value in the obj we sending

            let url = `/employees?page=${this.page}&take=${this.take}&sort=-id&include=salary`

            if (this.name) {
              url += `&filter[full_name]=${this.name}`
            }
            if (this.jobTitle && this.jobTitle.id) {
              url += `&filter[job_id]=${this.jobTitle.id}`
            }

            await this.getList(url)
            this.dataCount = this.all_data.total
            this.data = this.all_data.data
            this.data.map(e => {
              e.checked = false
            })
          }
        })
      }
    },
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true
        this.EditForm = {
          full_name: '',
          job_title: '',
          base_salary: '',
          _method: 'POST',
        }
      } else {
        this.createMode = false
        this.EditForm.id = item.id
        this.EditForm.full_name = item.full_name
        this.EditForm.job_title = item.job_id
        this.EditForm.base_salary = item.base_salary
        this.jobTitleObj = item.job
        this.EditForm._method = 'PUT'
      }
      this.$bvModal.show('modal-edit')
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode)
    },
    async getEmployeesList() {
      this.loading = true
      // check if there are any null value in the obj we sending

      let url = `/employees?page=${this.page}&take=${this.take}&sort=-id&include=salary,job`

      if (this.name) {
        url += `&filter[full_name]=${this.name}`
      }
      if (this.jobTitle && this.jobTitle.id) {
        url += `&filter[job_id]=${this.jobTitle.id}`
      }

      await this.getList(url)
      this.dataCount = this.all_data.total
      this.data = this.all_data.data
      this.data.map(e => {
        e.checked = false
      })
      this.loading = false
    },

    deleteModel(item) {
      this.deleteForm = item
      this.$bvModal.show('modal-delete')
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/employees/${this.deleteForm.id}`)
        .then(response => {
          this.getEmployeesList()

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: `deleted ${this.deleteForm.first_name} successfully`,
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: `Error deleting ${this.deleteForm.first_name}`,
            },
          })
        })
    },
    submitItem() {
      let count = 0
      this.loading = true
      this.errorForm.full_name = ''
      this.errorForm.job_title = ''
      for (const item in this.errorForm) {
        this.errorForm[item] = ''
        if (this.EditForm[item] == '' || this.EditForm[item] == null) delete this.EditForm[item]
      }

      if (!this.EditForm.full_name) {
        this.errorForm.full_name = 'The full name field is required.'
        count++
      }

      if (!this.EditForm.job_title) {
        this.errorForm.job_title = 'The job title field is required.'
        count++
      }

      if (count > 0) {
        this.loading = false
        return false
      }

      this.EditForm.job_id = (this.EditForm.job_title && this.EditForm.job_title.id)
        ? this.EditForm.job_title.id
        : this.EditForm.job_title
      if (this.createMode) {
        (this.params.form = this.EditForm),
        (this.params.path = '/employees'),
        this.$store
          .dispatch('create', this.params)
          .then(response => {
            this.getEmployeesList()
            this.loading = false
            this.$bvModal.hide('modal-edit')
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      } else {
        (this.params.form = this.EditForm),
        (this.params.path = `/employees/${this.EditForm.id}`),
        this.$store
          .dispatch('update', this.params)
          .then(response => {
            this.getEmployeesList()
            this.loading = false
            this.$bvModal.hide('modal-edit')
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400) {
              for (const item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              }
            }
          })
      }
    },
  },
}
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

</style>

<style>
@media print {
  body * {
    visibility: hidden !important;
  }

  #employee-print,
  #employee-print * {
    visibility: visible !important;
  }

  #employee-print {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
